import { Link, usePage } from "@inertiajs/react";

import logoWhite from "@/assets/logo_white.svg";
import { brandEmail } from "@/lib/brand";
import { contacts, registrations } from "@/routes";
import type { SharedProps } from "@/types";

export default function Footer() {
  const { currentUser } = usePage<SharedProps>().props;

  return (
    <footer className="bg-ink text-white">
      <div className="flex w-full flex-row items-start justify-between gap-6 px-4 py-8 sm:px-6 md:gap-10 md:py-14 lg:px-10">
        <img
          src={logoWhite}
          alt="Los Tilos"
          className="h-16 w-auto max-w-full self-start sm:h-28 md:h-40"
        />

        <div className="flex w-auto max-w-full flex-col items-start gap-3 font-sans text-xs sm:gap-5 sm:text-sm md:max-w-md">
          {!currentUser && (
            <Link
              href={registrations.new().url}
              className="rounded-full border border-white px-4 py-1.5 font-light uppercase tracking-wide transition-colors hover:bg-white hover:text-ink sm:px-6 sm:py-2"
            >
              Regístrate aquí
            </Link>
          )}

          <Link
            href={contacts.new().url}
            className="flex items-start gap-2 break-all transition-colors hover:text-olive"
          >
            <MailIcon className="mt-0.5 h-4 w-4 shrink-0" />
            Contáctanos
          </Link>

          <div className="w-full">
            <p className="font-semibold uppercase tracking-wide">
              Sitios de interés:
            </p>
            <a
              href="https://opusdei.org/es-cl/"
              className="block break-all hover:text-olive"
              target="_blank"
              rel="noreferrer"
            >
              https://opusdei.org/es-cl/
            </a>
            <a
              href="https://opusdei.org/es/youth/"
              className="block break-all hover:text-olive"
              target="_blank"
              rel="noreferrer"
            >
              https://opusdei.org/es/youth/
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function MailIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path strokeLinecap="round" strokeLinejoin="round" d="m3 7 9 6 9-6" />
    </svg>
  );
}
